import { render, staticRenderFns } from "./PropostaEnviadaCliente.vue?vue&type=template&id=67c2d48c&"
import script from "./PropostaEnviadaCliente.vue?vue&type=script&lang=js&"
export * from "./PropostaEnviadaCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports